export default __webpack_public_path__ + "static/media/projectChair.ed0231fe.bin";